<template>
    <div class="card card-primary card-outline" style="overflow: auto;">
        <div class="card-body box-profile">
            <ul class="list-group list-group-unbordered">
                <li class="list-group-item" style="border-top:none">
                    <label>
                        {{ $t('general.Tipo Daño') }}
                    </label><br>
                    <Dropdown style="width:100%;" @change="cambiartipodano()" attach v-model="selected"
                        :options="tipos_danyo" scrollHeight="600px" filter placeholder="Tipos daño">
                    </Dropdown>
                </li>
                <li class="list-group-item" v-if="servicio" :title="'Última modificación por: '+servicio.fecha_espera.usuario">
                    <label>
                        Fecha de espera
                    </label><br>
                    <Calendar v-if="!parametroHora" @date-select="modificarFechaEspera()" v-model="fecha_espera" showOtherMonths="true" selectOtherMonths="true"
                        class="selector-filtro" style="width:100%;" dateFormat=" dd/mm/yy"  placeholder="Sin fecha de espera"/>
                    <Calendar v-else @date-select="modificarFechaEsperaConHoras()" v-model="fecha_espera" showOtherMonths="true" selectOtherMonths="true" :stepMinute="10" showTime hourFormat="24"
                        class="selector-filtro" style="width:100%;" dateFormat=" dd/mm/yy"  placeholder="Sin fecha de espera"/>
                </li>
                <li class="list-group-item">
                    <label>
                        Estado pendiente de
                    </label><br>
                    <Dropdown style="width:100%;" class="esppendiente" optionGroupChildren="items" optionGroupLabel="label" 
                    scrollHeight="600px" @click="permitircambio()" @change="observacionesObligatorias()" attach v-model="estadopenselec"
                        :options="estadospendientes" optionValue="id_estado" filter
                        optionLabel="nombre" placeholder="Estado pendiente">
                    </Dropdown>
                    <div v-if="mostrardescripcion == true">
                        <p></p>
                        <div v-if="formularioTelefonos">
                            <label for="">Teléfono del evento para la acción de: Realizar LLAMADA/Enviar SMS/Enviar WHATSAPP</label>
                            <label for="">{{ telefonos[0].nombre }}</label>
                            <div style="display: grid;">
                                <div style="display: flex;">
                                    <input  type="radio" :disabled="!telefonos[0].telefono" :value="telefonos[0]" v-model="telefonomarcado">
                                    <p style="margin-bottom: 0; margin-left: 5px;">Teléfono 1: {{ telefonos[0].telefono }}</p>
                                </div>       
                                <p>Descripción: {{ telefonos[0].descripcion }}</p>
                            </div>
                            <div style="display: grid;">
                                <div style="display: flex;">
                                    <input type="radio" :disabled="!telefonos[1].telefono" :value="telefonos[1]" v-model="telefonomarcado">
                                    <p style="margin-bottom: 0; margin-left: 5px;">Teléfono 2: {{ telefonos[1].telefono }}</p>
                                </div>                        
                                <p>Descripción: {{ telefonos[1].descripcion }}</p>
                            </div>
                            <div style="display: grid;">
                                <div style="display: flex;">
                                    <input type="radio" :disabled="!telefonos[2].telefono" :value="telefonos[2]" v-model="telefonomarcado">
                                    <p style="margin-bottom: 0; margin-left: 5px;">Teléfono 3: {{ telefonos[2].telefono }}</p>
                                </div>                                
                                <p>Descripción: {{ telefonos[2].descripcion }}</p>
                            </div>
                            <p></p>
                        </div>
                        <label>
                            Descripción
                        </label>
                        <Textarea rows="4" @keydown.esc="mostrardescripcion=false"
                            v-model="descripcioncambioestado"></Textarea>
                        <p></p>
                        <div v-if="formularioRetrasar">
                            <label for="">Retrasar ejecución del evento</label>
                            <select class="form-control form-control-sm" id="" v-model="retrasarseleccionada">
                                <option v-for="opcion in retrasaropciones" :value="opcion" :key="opcion">{{ opcion }}</option>
                            </select>
                            <div v-if="retrasarseleccionada == 'Fecha'">
                                <p></p>
                                <div>
                                    <Calendar style="width: 100%;" v-model="fecharetraso" :stepMinute="5" showTime hourFormat="24"
                                    dateFormat="dd/mm/yy" class="selector-filtro"/>
                                </div>
                            </div>
                            <div v-if="retrasarseleccionada == 'Horas'">
                                <p></p>
                                <div style="display: flex; gap: 20px;">
                                    <input min="0" type="number" class="form-control form-control-sm" v-model="horasretraso">
                                </div>
                            </div>
                            <p></p>
                        </div>
                        <Button @click="actualizarEstadoPendienteConObservaciones()">Guardar</Button>
                    </div>
                </li>

                <li class="list-group-item">
                    <label class="labelmostrar mr-2" @click="mostrarhistorial = !mostrarhistorial" style="margin:0px;">Historial de estados</label><i class="fas fa-plus" style="cursor:pointer;" @click="mostrarhistorial = !mostrarhistorial"></i>&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleoverlay($event)" style="cursor:pointer;"><i class="fas fa-eye"></i>
</span>
                    <OverlayPanel ref="opestado" appendTo="body" class="mi-overlay">
                        <div class="overlay-scroll">
                        <table class="table table-sm sticky-table">
                            <thead>
                                <tr>
                                    <th style="background-color: white">{{ $t('general.fecha') }}</th>
                                    <th style="background-color: white">{{ $t('general.usuario') }}</th>
                                    <th style="background-color: white">Estado</th>
                                    <th style="background-color: white">Observaciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="historial in seguimientoEstados" :key="historial.id_seguimiento">
                                    <td style="width:180px">{{ historial.fecha.split(':').slice(0, 2).join(':') }}</td>
                                    <td>{{ historial.usuario }}</td>
                                    <td>{{ historial.estado }}</td>
                                    <td v-if="historial.detalle">{{ historial.detalle }}</td>
                                </tr> 
                                
                            </tbody>
                           <!-- <tbody v-else>                                
                                <div v-for="historial in seguimientoEstados"
                                    :key="historial.id_seguimiento">
                                    <tr >
                                        <td style="width:180px">{{ historial.fecha.split(':').slice(0, 2).join(':') }}</td>
                                        <td>{{ historial.usuario }}</td>
                                        <td>{{ historial.estado }}</td>
                                    </tr> 
                                    <tr>
                                        <td colspan="4" v-if="historial.detalle">{{ historial.detalle }}</td>
                                    </tr>
                                    <hr style="margin: 0; border-top: 1px solid rgba(0,0,0,.125);" />
                                </div>                               
                            </tbody>-->
                        </table>
                        </div>
                    </OverlayPanel>
                    <div v-if="mostrarhistorial == true" class="scroll">
                        <table class="table table-sm tablapers compact-table">
                            <tbody >
                                <tr v-for="historial in seguimientoEstados" :key="historial.id_seguimiento" class="compact-row">
                                    <td>
                                        <div class="linea-principal">
                                            {{ historial.fecha.split(':').slice(0, 2).join(':') }} | {{ historial.usuario.length > 15 ? historial.usuario.slice(0, 12) + '...' : historial.usuario }}
                                        </div>
                                        <div class="linea-estado">
                                            {{ historial.estado }}
                                        </div>
                                        <div v-if="historial.detalle" class="linea-detalle">
                                            {{ historial.detalle }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                       <!-- <table v-else class="table table-sm">
                            <tbody>                                
                                <div v-for="historial in seguimientoEstados"
                                    :key="historial.id_seguimiento">
                                    <tr >
                                        <td style="width:180px">{{ historial.fecha }}</td>
                                        <td>{{ historial.usuario }}</td>
                                        <td>{{ historial.estado }}</td>
                                    </tr> 
                                    <tr>
                                        <td colspan="4" v-if="historial.detalle">{{ historial.detalle }}</td>
                                    </tr>
                                    <hr style="margin: 0; border-top: 1px solid rgba(0,0,0,.125);" />
                                </div>                               
                            </tbody>
                        </table>-->
                    </div>
                </li>
                <li class="list-group-item" style="border-bottom:none">
                    <div class="custom-control custom-checkbox">
                        <div class="row">
                            <div class="col-md-6">
                                <input class="custom-control-input custom-control-input-warning" type="checkbox"
                                    @change="modificarConflictivo()" id="conflict" v-bind:true-value="1"
                                    v-bind:false-value="0" v-model="conflictivo">
                                <label for="conflict" class="custom-control-label">Conflictivo</label>
                            </div>
                            <div class="col-md-2"></div>
                            <div class="col-md-4">
                                <input class="custom-control-input custom-control-input-danger" type="checkbox"
                                    @change="modificarUrgente()" id="urgented" v-bind:true-value="1"
                                    v-bind:false-value="0" v-model="urgente">
                                <label for="urgented" class="custom-control-label">Urgente</label>
                            </div>
                        </div>
                    </div>
                </li>

                <!--<li class="list-group-item"
                    v-if="this.$props.servicioext.datos.fecha_asignacion_companyia_servicio != '0'">
                    <b>Asignación</b>
                    <p class="float-right" style="color:rgb(0, 123, 255)">{{ fecha_asigna }}</p>
                </li>-->
                <!-- <li class="list-group-item">
                    <b>Última visita</b> <a class="float-right">15/12/2021</a>
                </li>-->
                <!-- <li class="list-group-item">
                    <b>Sin actualizar</b>
                    <p class="float-right " style="color:rgb(0, 123, 255)">{{fecha_actualiza}}</p>
                </li>-->

                <li v-if="servicio.reasignado != '1'" class="list-group-item" style="border-bottom:none">
                    <Button @click="confirmar1()" label="Reasignar expediente"
                        style="font-weight:bold;width:-moz-available;background-color:#dc3545;border-color:#dc3545;border-radius:0.25rem;width:100%;"></Button>
                </li>
                <!-- <li class="list-group-item">
                    <label class="labelmostrar" @click="mostrarExpedientes= !mostrarExpedientes">
                        Expedientes relacionados <i class="fa fa-eye" aria-hidden="true"></i>
                    </label>
                    <div v-if="mostrarExpedientes==true" class="scroll">
                        <table class="table table-sm">
                            <tbody>
                                <tr v-for="siniestro in servicio.siniestros_relacionados" :key="siniestro.id_servicio">
                                    <td>{{ siniestro.codigo }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </li>---->
            </ul>
        </div>
    </div>



</template>

<script>
import Textarea from 'primevue/textarea';
import { PwgsApi } from '../../../../services/PwgsApi';
import Dropdown from 'primevue/dropdown';
import OverlayPanel from 'primevue/overlaypanel';
export default ({
    props: ['id', 'servicio', 'fecha', 'servicioext','estadospendientes'],
    components: {
        Dropdown,Textarea,OverlayPanel
    },
    setup() {
        return; 
    },
    data() {
        return {
            seguimientoEstados: [],
            parametroHora:false,
            horasretraso:0,
            fecharetraso:'',
            retrasaropciones:['No retrasar', 'Horas', 'Fecha'],
            retrasarseleccionada:'No retrasar',
            telefonos:[],
            telefonomarcado:null,
            formularioTelefonos:false,
            formularioRetrasar:false,
            nocambiar:false,
            tipos:[],
            selected: '',
            date: '',
            fecha_actualiza: '',
            fecha_espera: '',
            fecha_asigna: '',
            tipos_danyo: [],
            estadopenselec: '',
            estadopenactual:'',
            mostrarhistorial:false,
            mostrarExpedientes:false,
            conflictivo: 0,
            urgente: '',
            editar: false,
            pausado: '',
            descripcioncambioestado:'',
            direccionglobal: 'https://' + localStorage.getItem('direccion'),
            mostrardescripcion:false,
            servicioauxiliar: { especialidad_pendiente: { seguimiento: { idseguimiento: '' } } },
        }
    },
    methods: {
        async cargardatos() {                          
            // this.estadopenselec = '';
            const api = new PwgsApi();
            localStorage.setItem('permitirfechaespera' + this.$props.id, "true");
            const hora = await api.get('parametros-pwgs/hora_espera');
            if(hora.hora_espera == 1){
                this.parametroHora = true
            }
            this.fecha_actualiza = new Date(this.servicioext.datos.fecha_actualiza).toLocaleDateString('es');
            if (this.servicioext.datos.fecha_espera == '0000-00-00') {                
                this.fecha_espera = '';
            }else{
                if(this.parametroHora == true){
                    if(this.servicioext.datos.hora_espera == '00:00:00' || this.servicioext.datos.hora_espera == ''){
                        this.fecha_espera = new Date(this.servicioext.datos.fecha_espera+' 00:00');
                    }else{
                        var horaPartida = this.servicioext.datos.hora_espera.split(':');
                        var horaMinutos = horaPartida[0] + ':' + horaPartida[1];                         
                        this.fecha_espera = new Date(this.servicioext.datos.fecha_espera + ' ' + horaMinutos);
                    }
                }else{
                    this.fecha_espera = new Date(this.servicioext.datos.fecha_espera);
                }
            }
            this.fecha_asigna = new Date(this.servicioext.datos.fecha_crear_servicio).toLocaleDateString('es');
            this.selected = this.servicioext.datos.tipo_danyo_servicio;
            this.estadopenselec = this.servicioext.datos.id_especialidad_asignada_servicio;
            this.estadopenactual = this.estadopenselec;
            this.urgente = this.servicioext.datos.urgente_servicio;
            this.pausado = this.servicioext.datos.pausado;
            this.direccionglobal = 'https://' + localStorage.getItem('direccion');
            console.log("direccionglobal666", this.direccionglobal);

        },
        fechaing(fecha) {
            const [dia, mes, año] = fecha.split("/");
            return `${año}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
        },
        confirmar1() {
            this.$confirm.require({
                message: '¿Seguro que quieres reasignar el servicio?',
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                rejectClass: 'p-button-secondary p-button-outlined',
                rejectLabel: 'Cancelar',
                acceptLabel: 'Aceptar',
                accept: () => {
                    this.reasignar();
                },
                reject: () => {
                    return;
                }
            });
        },
        async reasignar() {
            const api = new PwgsApi();
            let idservicio = await api.put('servicios/' + this.$props.id + '/reasignar');

            this.$toast.add({ severity: 'success', summary: 'Reasignado', detail: 'Servicio reasignado correctamente', life: 2000 });
            this.iraservicio(idservicio.id, this.$props.servicio.codigo);
        },
        iraservicio(idruta, codigo) {

            localStorage.setItem('nombreservicio' + idruta, codigo);

            this.$router.push('/servicios/' + idruta);
        }, 
        async cargartiposdanyo() {
            const api = new PwgsApi();            
            const defecto = await api.get('parametros-pwgs/mostrar_estado_seguimiento');
            if(defecto.mostrar_estado_seguimiento == 1){
                this.mostrarhistorial = true
            }
            const datos = await api.get('tipos-dano');
            const aux = datos.datos;
            for (let i = 0; i < aux.length; i++){
                this.tipos_danyo.push(aux[i].danyo);
            }
        },
        async cambiartipodano() {
            const api = new PwgsApi();
            let subidadatos = {tipo_dano:this.selected}
            try {
                await api.put('servicios/' + this.$props.id + '/modificar-servicio', subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Tipo de daño guardado correctamente', life: 2000 });

                if (this.$props.servicio.campos_obligatorios.tipo_danyo_servicio == 1) {
                    localStorage.setItem('permitirtipodanyo' + this.$props.id, "true");
                    window.dispatchEvent(new CustomEvent('guardadotipodanyo'));
                }

            }
              catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

            }
            this.$parent.$parent.cargardatos(this.$props.id);
            this.$parent.$parent.cargarmasdatos();
        },
        sacarfecha(alrm) {
            var fecha = new Date(alrm).toLocaleDateString("es-ES", { day: 'numeric' }) + "/" + new Date(alrm).toLocaleDateString("es-ES", { month: 'numeric' }) + "/" + new Date(alrm).toLocaleDateString("es-ES", { year: 'numeric' });
            var hora = new Date(alrm).toLocaleTimeString("es-ES", { hour: '2-digit'});
            var minuto = new Date(alrm).toLocaleTimeString("es-ES", { minute: '2-digit' });
            return fecha+' '+hora+':'+minuto;
        },
        async actualizarEstadoPendienteConObservaciones() {
            //put  modulos/pwgsapi/index.php/servicios/:id/modificar-estado-pendiente
            if(this.descripcioncambioestado.length < 1 && this.$props.servicio.campos_obligatorios.especialidad_pendiente_observaciones==1){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: "Debe rellenar la descripcion", life: 5000 });
                return;
            }
            const api = new PwgsApi();
            let subidadatos = { id_esp_pend: this.estadopenselec};
            if (this.descripcioncambioestado.length > 0) {
            subidadatos.observaciones =this.descripcioncambioestado;
            }
            if(this.formularioTelefonos && this.telefonomarcado){
                subidadatos.telefono_evento = this.telefonomarcado.telefono;
            }
            if(this.formularioRetrasar){
                if(this.retrasarseleccionada == 'Horas' && this.horasretraso > 0){
                    var ahora = new Date();
                    ahora.setHours(ahora.getHours() + this.horasretraso)
                    var valorh = this.sacarfecha(ahora);
                    subidadatos.fecha_retraso_ejecucion_evento = valorh;
                }
                if(this.retrasarseleccionada == 'Fecha' && this.fecharetraso){
                    var valorf = this.sacarfecha(this.fecharetraso);
                    subidadatos.fecha_retraso_ejecucion_evento = valorf;
                }
            }
           try{
                this.nocambiar = true;
                await api.put('servicios/' +this.$props.id+'/modificar-estado-pendiente',subidadatos);
               this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Estado guardado correctamente', life: 2000 });
               this.mostrardescripcion = false;
               this.$parent.$parent.cargarmasdatos();
                setTimeout(() => {
                    this.cargardatos();
                }, 2500); 
                localStorage.setItem('permitir' + this.$props.id, "true");
                window.dispatchEvent(new CustomEvent('guardadoestadopendiente'));
                const datos = await api.get("servicios/" + this.$props.id + '/datos-basicos');
                this.seguimientoEstados = datos.especialidad_pendiente.seguimiento;
           }
           catch (error) {
               this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
           }
            
        },
        async observacionesObligatorias() {
            const api = new PwgsApi();
            var sinobservaciones = await api.get('parametros-pwgs/especialidad_pendiente_sin_observaciones');
            if(sinobservaciones.especialidad_pendiente_sin_observaciones == 1){
                this.actualizarEstadoPendiente();
            }
            else{

                if(this.estadopenactual == this.estadopenselec){
                    localStorage.setItem('permitir' + this.$props.id, "true");
                    window.dispatchEvent(new CustomEvent('guardadoestadopendiente'));
                }else{
                    const resp = await api.get('servicios/'+this.id+'/evento-cambio-estado/'+this.estadopenselec);
                    if(resp.telefonos_evento){
                        this.formularioTelefonos = true;
                        this.telefonos = [];
                        for(let tlfo of Object.values(resp.telefonos_evento[0])){
                            var tlf = {
                                telefono: tlfo.id,
                                nombre: tlfo.nombre,
                                descripcion: tlfo.descripcion,
                            }
                            if(tlfo.checked){
                                this.telefonomarcado = tlf;
                            }
                            this.telefonos.push(tlf);
                        }
                    }else{
                        this.formularioTelefonos = false;
                    }
                    if(resp.evento_cambio_estado_retrasar_ejecucion && resp.evento_cambio_estado_retrasar_ejecucion == '1'){
                        this.formularioRetrasar = true;
                    }else{
                        this.formularioRetrasar = false;
                    }
                    this.mostrardescripcion = true;                  
                }
            }
        },
        permitircambio() {

                localStorage.setItem('permitir' + this.$props.id, "true");
                window.dispatchEvent(new CustomEvent('guardadoestadopendiente'));
            
        },
        async actualizarEstadoPendiente() {
            //put  modulos/pwgsapi/index.php/servicios/:id/modificar-estado-pendiente
            const api = new PwgsApi();
                let subidadatos = { id_esp_pend: this.estadopenselec }
                try {
                    await api.put('servicios/' + this.$props.id + '/modificar-estado-pendiente', subidadatos);
                    this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Estado guardado correctamente', life: 2000 });
                    this.mostrardescripcion = false;
                    this.$parent.$parent.cargarmasdatos();
                    setTimeout(() => {
                        this.cargardatos();
                    }, 2500);                         
                    localStorage.setItem('permitir' + this.$props.id, "true");
                    window.dispatchEvent(new CustomEvent('guardadoestadopendiente'));
                    

                }
                catch (error) {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

                }
           
        },
        async modificarUrgente() {
            //put  modulos/pwgsapi/index.php/servicios/:id/modificar-servicio
            let subidadatos = { urgente: this.urgente };
            const api = new PwgsApi();
            try{
                await api.put("servicios/" + this.$props.id + "/modificar-servicio", subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Estado urgente guardado correctamente', life: 2000 });
                this.cargardatos(this.$props.id);
                this.$parent.$parent.cargardatos(this.$props.id);
                this.$parent.$parent.cargarmasdatos();
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async modificarConflictivo() {
            //put  modulos/pwgsapi/index.php/servicios/:id/modificar-servicio
            let subidadatos = { conflictivo: this.conflictivo };
            const api = new PwgsApi();
            try{
                await api.put("servicios/" + this.$props.id + "/modificar-servicio", subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Estado conflictivo guardado correctamente', life: 2000 });
                this.cargardatos(this.$props.id);
                this.$parent.$parent.cargardatos(0, "cual", "si");
                this.marcarConflictivo();
            }
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });
            }
        },
        async  modificarPausado() {
            //put  modulos/pwgsapi/index.php/servicios/:id/modificar-servicio
           let subidadatos = { pausado: this.pausado };
           if (this.pausado == "SI") {
               subidadatos.pausado = 1;
           }
           const api = new PwgsApi();
           try{
           await api.put("servicios/" + this.$props.id + "/modificar-servicio", subidadatos);
           this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Servicio pausado correctamente', life: 2000 });
               this.cargardatos(this.$props.id);
           }
           catch (error) {
               this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

           }

        },
        async modificarFechaEspera() {
            //put  modulos/pwgsapi/index.php/servicios/:id/modificar-servicio
            const api = new PwgsApi();
            let auxespera = new Date(this.fecha_espera).addHours(4).toISOString().split('T')[0];
            //let auxesperahora = new Date(this.fecha_espera).toISOString().split('T')[1].split('.')[0];
            let subidadatos = { fecha_espera: auxespera};
            try {
                await api.put("servicios/" + this.$props.id + "/modificar-servicio", subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Fecha guardada correctamente', life: 2000 });
                this.editar = false;
            /*if (this.$props.servicio.campos_obligatorios.fecha_espera == 1) {
                
                let fechaespera = new Date(this.fecha_espera);
                let hoy = new Date();
                if (fechaespera < hoy ) {
                    localStorage.setItem('permitirfechaespera' + this.$props.id, "false");

                }
            }
            else {
                localStorage.setItem('permitirfechaespera' + this.$props.id, "true");
                }
                window.dispatchEvent(new CustomEvent('guardadofechaespera'));
                this.$parent.$parent.cargardatos();
                this.$parent.$parent.cargarmasdatos();
                this.cargardatos(this.$props.id);
            }*/}
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

            }
        },
         async modificarFechaEsperaConHoras() {
            //put  modulos/pwgsapi/index.php/servicios/:id/modificar-servicio
            const api = new PwgsApi();           
            let auxespera = new Date(this.fecha_espera).addHours(2).toISOString().split('T')[0];
            let subidadatos = {};
            if(this.parametroHora){
                let horaespera = new Date(this.fecha_espera).addHours(2).toISOString().split('T')[1].split('.')[0];
                let horaMinutos = horaespera.split(':');
                horaespera = horaMinutos[0] + ':' + horaMinutos[1] + ':00';
                subidadatos = { fecha_espera: auxespera, hora_espera: horaespera};
            }else{
                subidadatos = { fecha_espera: auxespera};
            }
            try {
                await api.put("servicios/" + this.$props.id + "/modificar-servicio", subidadatos);
                this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Fecha guardada correctamente', life: 2000 });
                this.editar = false;
            /*if (this.$props.servicio.campos_obligatorios.fecha_espera == 1) {
                
                let fechaespera = new Date(this.fecha_espera);
                let hoy = new Date();
                if (fechaespera < hoy ) {
                    localStorage.setItem('permitirfechaespera' + this.$props.id, "false");

                }
            }
            else {
                localStorage.setItem('permitirfechaespera' + this.$props.id, "true");
                }
                window.dispatchEvent(new CustomEvent('guardadofechaespera'));
                this.$parent.$parent.cargardatos();
                this.$parent.$parent.cargarmasdatos();
                this.cargardatos(this.$props.id);
            }*/}
            catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 5000 });

            }
        },
        async marcarConflictivo(){
            if(this.conflictivo==1){
                this.$parent.conflictivo=1;
            }else{
                this.$parent.conflictivo=0;
            }
        },
        toggleoverlay(event) {
            this.$refs.opestado.toggle(event);
        setTimeout(() => {
        this.$refs.opestado.align();
    }, 0);
        }
    },

    mounted() {        
        this.cargardatos(this.$props.id);
        this.cargartiposdanyo();
        localStorage.setItem('permitirfechaespera' + this.$props.id, "true");

    },
    activated() {
        localStorage.setItem('permitirfechaespera' + this.$props.id, "true");

      /*  if (this.servicio.tramitado != 1) {
            localStorage.setItem('permitirtipodanyo' + this.$props.id, "true");
            localStorage.setItem('permitirfechaespera' + this.$props.id, "true");
            localStorage.setItem('permitir' + this.$props.id, "true");



        }
  */

    },
 
    watch: {        
        servicioext() {            
            this.selected = this.servicio.tipo_dano;
            this.cargardatos(this.$props.id);
        },
        servicio() {
          
            this.seguimientoEstados = this.servicio.especialidad_pendiente.seguimiento;
            this.servicioaux = this.servicio;
            this.conflictivo = this.servicio.asegurado.conflictivo;
            if (this.$props.servicio.campos_obligatorios.especialidad_pendiente == 1) {
                if(!this.nocambiar){
                    localStorage.setItem('permitir' + this.$props.id, "false");
                }

            }
            else {
                localStorage.setItem('permitir' + this.$props.id, "true");
            }
            if (this.$props.servicio.campos_obligatorios.tipo_danyo_servicio == 1) {
                localStorage.setItem('permitirtipodanyo' + this.$props.id, "false");
            }
            else {
                localStorage.setItem('permitirtipodanyo' + this.$props.id, "true");
            }
            this.mostrardescripcion = false;
            this.descripcioncambioestado = '';
           /* if (this.$props.servicio.campos_obligatorios.fecha_espera == 1) {
                
                let fechaespera = new Date(this.fecha_espera);
                let hoy = new Date();
                if (fechaespera < hoy ) {
                    localStorage.setItem('permitirfechaespera' + this.$props.id, "false");

                }
            }
            else {
                localStorage.setItem('permitirfechaespera' + this.$props.id, "true");
            }*/
         /*   if (this.servicio.tramitado != 1) {
                localStorage.setItem('permitirtipodanyo' + this.$props.id, "true");
                localStorage.setItem('permitirfechaespera' + this.$props.id, "true");
                localStorage.setItem('permitir' + this.$props.id, "true");



            }*/
        },
    }
})
</script>
<style>
.mi-overlay .p-overlaypanel-content {
    padding-top: 0.25rem !important;
    z-index: 99999999 !important;
    max-width: 70vw;
}
.mi-overlay table{
    table-layout: fixed;
    width: 100%;
}
.mi-overlay td {
    overflow-wrap: anywhere;
}
.puntero {
    cursor: pointer !important;

}
.scroll{
    overflow: scroll;
}
.labelmostrar{
    cursor: pointer !important;
}
.overlay-scroll {
    max-height: 460px;
    overflow-y: auto;
    padding-right: 10px;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight{
    color: #004794;
    font-weight: bold;
}
.p-dropdown {
    min-width: 10rem;
}

.p-dropdown-label {
    display: flex;
    flex-wrap: wrap;
    height: auto;
    white-space: break-spaces;
}

.p-dropdown-token {
    margin: 0.1rem; }

.p-datepicker-other-month {
color: #bbb !important; /* Color más claro */
opacity: 0.6; /* Opcional, para dar apariencia atenuada */
}

/* Opcional: cambia el fondo al pasar el mouse */
.p-datepicker-other-month:hover {
  background-color: #f0f0f0;
}
.sticky-table thead th {
    position: sticky;
    top: 0;
    background: white; /* IMPORTANTE para que no se transparente */
    z-index: 1;
}

.tablapers {
    margin: 0 !important;
    border-collapse: collapse !important;
}

/* QUITA ESPACIOS ENTRE FILAS */
.tablapers td {
    padding: 2px 6px !important;  /* 👈 clave */
    border: none !important;
}

/* elimina separación entre tr */
.compact-row {
    margin: 0 !important;
    padding: 0 !important;
    border-bottom: 1px solid rgba(0,0,0,.06); /* opcional muy suave */
}

/* texto más compacto */
.linea-principal {
    font-weight: 500;
    line-height: 1.1;
    margin: 0;
}

.linea-estado {
    font-weight: 500;
    line-height: 1.1;
    margin: 0;
    color: #444;
}

.linea-detalle {
    font-weight: 500;
    line-height: 1.1;
    margin: 0;
    color: #777;
}






</style>
